import { useState, useEffect } from "react"
import { useParams, useLocation } from "react-router-dom"
import CoursesCard from "./CoursesCard"
import SEO from "../common/SEO"
import "./courses.css"

export default function CourseHome() {
  const { category, program } = useParams()
  const location = useLocation()
  const [selectedCategory, setSelectedCategory] = useState("all")

  useEffect(() => {
    if (category) {
      setSelectedCategory(category)
    } else if (program) {
      setSelectedCategory(program)
    } else if (location.pathname === "/degree-programs") {
      setSelectedCategory("university")
    } else {
      setSelectedCategory("all")
    }
  }, [category, program, location.pathname])

  return (
    <>
      <SEO
        title="Online Courses - International Education Programs"
        description="Explore our comprehensive range of online courses and international education programs. Expert-led courses for IELTS, TOEFL, GRE, GMAT, and study abroad preparation."
        keywords="online courses, international education programs, IELTS courses, TOEFL preparation, GRE courses, GMAT preparation, study abroad courses"
        url="/courses"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "Course",
          "name": "International Education Programs",
          "description": "Comprehensive online courses for international education",
          "provider": {
            "@type": "EducationalOrganization",
            "name": "WELSH EDUCATION GROUP"
          },
          "courseMode": "online",
          "educationalLevel": "higher education"
        }}
      />
      <div className="course-explorer-page">
        <CoursesCard selectedCategory={selectedCategory} />
      </div>
    </>
  )
}
